import React from 'react';

import { CustomSVGProps } from './CustomSVGProps.types';

export function IconCalender48(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="48"
            height="48"
            viewBox="0 0 48 48"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="calendar">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M40 9H8V41H40V9ZM8 7C6.89543 7 6 7.89543 6 9V41C6 42.1046 6.89543 43 8 43H40C41.1046 43 42 42.1046 42 41V9C42 7.89543 41.1046 7 40 7H8Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M41 17H7V15H41V17Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M15 2C15.5523 2 16 2.44772 16 3V11C16 11.5523 15.5523 12 15 12C14.4477 12 14 11.5523 14 11V3C14 2.44772 14.4477 2 15 2Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M33 2C33.5523 2 34 2.44772 34 3V11C34 11.5523 33.5523 12 33 12C32.4477 12 32 11.5523 32 11V3C32 2.44772 32.4477 2 33 2Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconCalender24(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="calendar">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M2 4C2 3.44772 2.44772 3 3 3H21C21.5523 3 22 3.44772 22 4V22C22 22.5523 21.5523 23 21 23H3C2.44772 23 2 22.5523 2 22V4ZM4 5V21H20V5H4Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M22 9H3V7H22V9Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M7 0C7.55228 0 8 0.447715 8 1V3C8 3.55228 7.55228 4 7 4C6.44772 4 6 3.55228 6 3V1C6 0.447715 6.44772 0 7 0Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17 0C17.5523 0 18 0.447715 18 1V3C18 3.55228 17.5523 4 17 4C16.4477 4 16 3.55228 16 3V1C16 0.447715 16.4477 0 17 0Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}

export function IconCalender16(props: CustomSVGProps): React.JSX.Element {
    return (
        <svg
            {...props}
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            aria-hidden={!props.onClick}
            aria-label="calendar">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M1 3C1 2.44772 1.44772 2 2 2H14C14.5523 2 15 2.44772 15 3V15C15 15.5523 14.5523 16 14 16H2C1.44772 16 1 15.5523 1 15V3ZM3 4V14H13V4H3Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 0C4.55228 0 5 0.447715 5 1V3C5 3.55228 4.55228 4 4 4C3.44772 4 3 3.55228 3 3V1C3 0.447715 3.44772 0 4 0Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M11 0C11.5523 0 12 0.447715 12 1V3C12 3.55228 11.5523 4 11 4C10.4477 4 10 3.55228 10 3V1C10 0.447715 10.4477 0 11 0Z"
                fill={props.fill || 'currentColor'}
            />
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 8H2V6H14V8Z"
                fill={props.fill || 'currentColor'}
            />
        </svg>
    );
}
